export const ActionTypes = {

    ACTIONTYPE_1: {
        text: 'Ersterhebung',
        value: 'actionType1',
        actionsEnabled: false, // hide actions selection field
        amountEnabled: false // hide amountValue and amountUnit fields
    },
    ACTIONTYPE_2: {
        text: 'Bekämpfung',
        value: 'actionType2',
        actionsEnabled: true,
        amountEnabled: true
    },
    ACTIONTYPE_3: {
        text: 'Kontrolle',
        value: 'actionType3',
        actionsEnabled: true,
        amountEnabled: true
    },

    list() {
        return [
            this.ACTIONTYPE_1,
            this.ACTIONTYPE_2,
            this.ACTIONTYPE_3
        ]
    },

    itemByValue(value) {
        let actionType = this.list().find(item => item.value === value)
        return typeof(actionType)==="undefined" ? false : actionType
    }
}
